'use client'

import { useQuery } from '@tanstack/react-query'
import { useSession } from './useSession'

/**
 * Hook to check if current user is an active referrer
 * Calls server-side API to verify referrer status (with React Query caching)
 */
export function useIsReferrer() {
  const { user, loading: userLoading } = useSession()

  const { data, isLoading, error } = useQuery({
    queryKey: ['referrer-status', user?.id],
    queryFn: async () => {
      if (!user) {
        return { isReferrer: false }
      }

      const response = await fetch('/api/ambassador/status')

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      return response.json()
    },
    enabled: !userLoading && !!user,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })

  return {
    isReferrer: data?.isReferrer || false,
    loading: userLoading || isLoading,
    error: error as Error | null,
  }
}
